var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"dashboard-banner__group-title"},[_vm._v(" "+_vm._s(_vm.showHour)+" : "+_vm._s(_vm.showMinute)+" : "+_vm._s(_vm.showSecound)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }